import { useEffect, useRef, useState } from "react";

const GLS_SCRIPT_URL = "https://map.gls-hungary.com/widget/gls-dpm.js";
const GLS_ELEMENT = "gls-dpm";

let glsScriptPromise;

function loadGlsScript() {
  if (glsScriptPromise) return glsScriptPromise;

  glsScriptPromise = new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${GLS_SCRIPT_URL}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = GLS_SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("gls_script_failed"));
    document.head.appendChild(script);
  });

  return glsScriptPromise;
}

function GlsPickupPicker({ t, lang, selected, onSelect }) {
  const mapRef = useRef(null);
  const onSelectRef = useRef(onSelect);
  const [mapLoading, setMapLoading] = useState(true);
  const [mapError, setMapError] = useState("");

  useEffect(() => {
    onSelectRef.current = onSelect;
  }, [onSelect]);

  useEffect(() => {
    let mapElement;
    let cancelled = false;

    function handleChange(event) {
      if (event.detail) {
        onSelectRef.current(event.detail);
      }
    }

    async function mountMap() {
      setMapLoading(true);
      setMapError("");

      try {
        await loadGlsScript();
        await customElements.whenDefined(GLS_ELEMENT);
        if (cancelled || !mapRef.current) return;

        mapElement = mapRef.current.querySelector(GLS_ELEMENT);
        if (!mapElement) {
          mapElement = document.createElement(GLS_ELEMENT);
          mapElement.className = "checkout-gls-map";
          mapElement.style.height = "100%";
          mapElement.style.width = "100%";
          mapRef.current.appendChild(mapElement);
        }

        mapElement.setAttribute("country", "hu");
        mapElement.setAttribute("language", lang === "en" ? "en" : "hu");
        mapElement.removeEventListener("change", handleChange);
        mapElement.addEventListener("change", handleChange);

        if (!cancelled) {
          setMapLoading(false);
        }
      } catch {
        if (!cancelled) {
          setMapLoading(false);
          setMapError(t.mapLoadError);
        }
      }
    }

    mountMap();

    return () => {
      cancelled = true;
      if (mapElement) {
        mapElement.removeEventListener("change", handleChange);
      }
    };
  }, [lang, t.mapLoadError]);

  const contact = selected?.contact || {};

  return (
    <div className="checkout-map-picker">
      {selected ? (
        <div className="checkout-selected-point" role="status">
          <p className="checkout-selected-point-name">{selected.name}</p>
          <p className="checkout-selected-point-address">
            {[contact.postalCode, contact.city, contact.address].filter(Boolean).join(", ")}
          </p>
        </div>
      ) : null}
      <div ref={mapRef} className="checkout-gls-map-wrap checkout-gls-map-wrap--tall">
        {mapLoading ? <p className="checkout-gls-map-loading">{t.mapLoading}</p> : null}
        {mapError ? <p className="checkout-modal-error">{mapError}</p> : null}
      </div>
    </div>
  );
}

export default GlsPickupPicker;
